module.exports = __webpack_public_path__ + "img/network-err.fdb41734.svg";